import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router";

const routeScrollContainerSelector = '[data-route-scroll-container="true"]';

// Keep SPA scroll behavior near the router because the router preserves scroll
// positions on PUSH/REPLACE navigations unless we reset active viewports here.
export function RouteScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const didMountRef = useRef(false);

  useLayoutEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    if (navigationType === "POP" || location.hash) {
      return;
    }

    resetWindowScroll();
    resetRouteScrollContainers();
  }, [location.hash, location.pathname, location.search, navigationType]);

  return null;
}

function resetWindowScroll() {
  window.scrollTo({ left: 0, top: 0 });
}

function resetRouteScrollContainers() {
  document.querySelectorAll<HTMLElement>(routeScrollContainerSelector).forEach((element) => {
    element.scrollTo({ left: 0, top: 0 });
  });
}
